import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "NewsCommentLike",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const {
  postNewsCommentLike,
  postNewsCommentLikeError,
  postNewsCommentLikeSuccess,
} = slice.actions;

reducerRegistry.register("newsCommentLike", reducer);
